import styled from 'styled-components';
import { prem } from 'styles/helpers/spacing';

export const TrimaCadranChipWrapper = styled.button<{ $selected?: boolean; $disabled?: boolean }>`
  display: inline-flex;
  align-items: center;
  padding: ${prem(8)} ${prem(14)};
  margin: 0;
  border-radius: ${prem(20)};
  border: 1px solid ${({ $selected }) =>
    $selected ? 'var(--ion-color-primary)' : 'var(--ion-color-light, #d8d8d8)'};
  background: ${({ $selected }) =>
    $selected ? 'var(--ion-color-primary)' : 'transparent'};
  color: ${({ $selected }) =>
    $selected ? 'var(--ion-color-primary-contrast, #fff)' : 'var(--ion-text-color)'};
  font-size: ${prem(13)};
  line-height: 1.2;
  font-family: inherit;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  user-select: none;
  opacity: ${({ $disabled }) => ($disabled ? 0.35 : 1)};
  transition: background 120ms ease,
    border-color 120ms ease,
    color 120ms ease,
    transform 80ms ease,
    opacity 150ms ease;

  &:active {
    transform: ${({ $disabled }) => ($disabled ? 'none' : 'scale(0.96)')};
  }

  &:focus {
    outline: none;
  }
`;
